import { CashoutHistoryGraphProps } from "@tipico/jack-time";
import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import { Cashout } from "../../components/Cashout/Cashout";
import { CashOutGraphFiltersProps } from "../../components/CashOutGraphFilters/CashOutGraphFilters";
import { StatsPanelProps } from "../../components/StatsPanel/StatsPanel";
import { NAVIGATION_STREAM } from "../../services/Navigation/navigateTo.hoc";
import NavigationEventDTO from "../../services/Navigation/NavigationEventDTO";
import CashoutValueDto from "../../services/CashoutValueDto";
export const TICKET_DETAILS_STATE = "CashoutTicketData";
export const TICKET_DETAILS_ACTION = "executeCashoutRequest";

type Actions = {
    sendBackAction: () => NavigationEventDTO;
    cashoutHandler: (cashoutValueDto: CashoutValueDto) => CashoutValueDto;
};

const actionsCreators: ActionsCreators<Actions> = {
    cashoutHandler: {
        creator: (cashoutValueDto: CashoutValueDto): CashoutValueDto =>
            cashoutValueDto,
        name: TICKET_DETAILS_ACTION
    },
    sendBackAction: {
        creator: () => ({ route: "BACK", parameters: {} }),
        name: NAVIGATION_STREAM
    }
};

const INITIAL_STATE: TicketDetailsStreamProps = {
    ticketMaxPrize: 0,
    ticketNumber: 0,
    ticketStake: 1
};

type ExternalProps = {
    currentValue?: number;
    currentTimestamp?: number;
    className?: string;
    children: string;
    isBlocked: boolean;
    isError: boolean;
};

export interface TicketDetailsStreamProps {
    ticketMaxPrize: number;
    ticketNumber: number;
    ticketStake: number;
}

export const CashoutContainer = connectToJava<
    ExternalProps &
        CashOutGraphFiltersProps &
        CashoutHistoryGraphProps &
        StatsPanelProps,
    TicketDetailsStreamProps,
    {
        [TICKET_DETAILS_STATE]: TicketDetailsStreamProps;
    },
    Actions
>({
    actionsCreators,
    state: {
        [TICKET_DETAILS_STATE]: INITIAL_STATE
    },
    stateMapper: ({ CashoutTicketData: state }) => state
})(Cashout);
